import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import { LinesTypes, LineInterface, ConectivityInterfacce } from './types';

// List Lines
export const listLinesRequest = (payload: {
  params?: object;
  filtering?: boolean;
  loading?: boolean;
  recovers?: string;
  body?: Object;
}) => action(LinesTypes.LIST_LINES_REQUEST, payload);
export const listLinesSuccess = (payload: {
  linesList: LineInterface[];
  totalCount: number;
}) => action(LinesTypes.LIST_LINES_SUCCESS, payload);
export const listLinesFailure = () => action(LinesTypes.LIST_LINES_FAILURE);

// Filter Lines
export const filterLinesRequest = (payload: object) =>
  asyncAction(LinesTypes.FILTER_LINES_REQUEST, payload);
export const filterLinesSuccess = (payload: {
  linesList: LineInterface[];
  totalCount: number;
}) => action(LinesTypes.FILTER_LINES_SUCCESS, payload);
export const filterLinesFailure = () => action(LinesTypes.FILTER_LINES_FAILURE);

// Get Line
export const getLineRequest = (payload: {
  params?: any;
  loading?: boolean;
  recovers?: string;
  body?: Object;
}) => asyncAction(LinesTypes.GET_LINE_REQUEST, payload);
export const getLineSuccess = (payload: { lineData: LineInterface }) =>
  action(LinesTypes.GET_LINE_SUCCESS, payload);
export const getLineFailure = () => action(LinesTypes.GET_LINE_FAILURE);

// Create Line
export const createLineRequest = (payload: any) =>
  asyncAction(LinesTypes.CREATE_LINE_REQUEST, payload);
export const createLineSuccess = (payload: { lineData: LineInterface }) =>
  action(LinesTypes.CREATE_LINE_SUCCESS, payload);
export const createLineFailure = () => action(LinesTypes.CREATE_LINE_FAILURE);

// Update Line
export const updateLineRequest = (payload: any) =>
  asyncAction(LinesTypes.UPDATE_LINE_REQUEST, payload);
export const updateLineSuccess = () => action(LinesTypes.UPDATE_LINE_SUCCESS);
export const updateLineFailure = () => action(LinesTypes.UPDATE_LINE_FAILURE);

// Delete Line
export const deleteLineRequest = (payload: any) =>
  action(LinesTypes.DELETE_LINE_REQUEST, payload);
export const deleteLineSuccess = () => action(LinesTypes.DELETE_LINE_SUCCESS);
export const deleteLineFailure = () => action(LinesTypes.DELETE_LINE_FAILURE);

// Update Line Benefits
export const updateLineBenefitsRequest = (payload: any) =>
  asyncAction(LinesTypes.UPDATE_LINE_BENEFITS_REQUEST, payload);
export const updateLineBenefitsSuccess = () =>
  action(LinesTypes.UPDATE_LINE_BENEFITS_SUCCESS);
export const updateLineBenefitsFailure = () =>
  action(LinesTypes.UPDATE_LINE_BENEFITS_FAILURE);

// Get Conectivity
export const conectivityRequest = (payload: object) =>
  asyncAction(LinesTypes.CONECTIVITY_REQUEST, payload);
export const conectivitySuccess = (payload: {
  conectivityData: ConectivityInterfacce;
}) => action(LinesTypes.CONECTIVITY_SUCCESS, payload);
export const conectivityFailure = (payload: {
  internalCode?: string;
  conectivityError?: string;
}) => action(LinesTypes.CONECTIVITY_FAILURE, payload);

export const conectivityDataPlanSuccess = (payload: {
  conectivityDataPlanList: ConectivityInterfacce;
}) => action(LinesTypes.CONECTIVITY_DATA_PLAN_SUCCESS, payload);

// Update Line Fare
export const updateLineFareRequest = (payload: any) =>
  asyncAction(LinesTypes.UPDATE_LINE_FARE_REQUEST, payload);
export const updateLineFareSuccess = () =>
  action(LinesTypes.UPDATE_LINE_FARE_SUCCESS);
export const updateLineFareFailure = () =>
  action(LinesTypes.UPDATE_LINE_FARE_FAILURE);
